<adapt-dialog [maxWidth]="640"
              [minWidth]="480"
              [maxHeight]="400">
    <h3 adapt-dialog-title>Participants for survey: {{ survey.name }}</h3>

    <div adapt-dialog-content
         class="h-100">
        <div *adaptLoadingUntilFirstEmit="let suppData of surveySuppData$"
             class="row h-100">
            <div class="col">
                <h3>Participants</h3>
                @if (suppData?.respondents) {
                    <div class="scrollable-textarea">
                        <pre>{{ suppData!.respondents }}</pre>
                    </div>
                } @else {
                    <p>No participants were recorded for this survey.</p>
                }
            </div>
            <div class="col">
                <h3>Non-participants</h3>
                @if (suppData?.nonrespondents) {
                    <div class="scrollable-textarea">
                        <pre>{{ suppData!.nonrespondents }}</pre>
                    </div>
                } @else {
                    <p>No non-participants were recorded for this survey.</p>
                }
            </div>
        </div>
    </div>

    <div adapt-dialog-footer
         class="ms-auto">
        <button #focus
                adaptButton="close"
                (click)="cancel()"></button>
    </div>
</adapt-dialog>
